import type { T3InitialData } from '@t3headless/nuxt-typo3'
import { type MaybeRef, computed, unref } from 'vue'

import { useT3Options } from '#imports'

export const usePageDataFooter = (
  _initialData: MaybeRef<T3InitialData | null>
) => {
  const initialData = computed(() => unref(_initialData))
  const { options } = useT3Options()

  const navigation = computed(() => {
    const navigation = initialData.value?.footerNavigation
    return Array.isArray(navigation) ? navigation : []
  })

  const contactData = computed(() => {
    const data = initialData.value?.footerContactData?.content?.items
    if (!Array.isArray(data)) return []
    return data.map(({ content, id }) => ({ id, ...content }))
  })

  const isMainPage = computed(() => !options.api.baseUrl?.includes('t3headless'))

  const socialNavigation = computed(() => {
    const navigation = initialData.value?.socialMenu
    return Array.isArray(navigation) ? navigation : []
  })

  return {
    navigation,
    socialNavigation,
    contactData,
    isMainPage
  }
}
